import { User } from "models/User";

import { getAPIService, postAPIService } from "./BaseServce";

export const getPhoneCountry = async () => {
  const res = await getAPIService("/auth/phone-verification/country");
  return res.data as { country: string | null; dial_code: string | null };
};

export const sendPhoneVerification = async (phoneNumber: string) => {
  const res = await postAPIService("/auth/phone-verification/send", {
    phone_number: phoneNumber,
  });
  return res.data as {
    phone_number: string;
    phone_number_display: string;
    detail: string;
  };
};

export const verifyPhone = async (phoneNumber: string, code: string) => {
  const res = await postAPIService("/auth/phone-verification/verify", {
    phone_number: phoneNumber,
    code,
  });
  return res.data as { data: User };
};
